import gql from 'graphql-tag';

const SAVE_APP_PERSONALIZATION = gql`
  mutation($input: PersonalizationInput!) {
    saveAppPersonalization(input: $input) {
      name
      value
    }
  }
`;

const GET_APP_PERSONALIZATION = gql`
  query($input: PersonalizationInput!) {
    getAppPersonalization(input: $input) {
      name
      value
    }
  }
`;

export { SAVE_APP_PERSONALIZATION, GET_APP_PERSONALIZATION };
